export const loading = {
  namespaced: true,
  state: () => ({
    loadingCount: 0,
    loadingActiveSubscription: false,
    loadingMessage: null
  }),
  mutations: {
    startLoading (state, message = null) {
      state.loadingCount++
      if (message !== null || !state.loadingMessage) {
        state.loadingMessage = message
      }
    },
    stopLoading (state) {
      state.loadingCount = Math.max(0, state.loadingCount - 1)

      if (state.loadingCount === 0) {
        state.loadingMessage = null
      }
    },
    resetLoading (state) {
      state.loadingCount = 0
      state.loadingMessage = null
    },
    setLoadingMessage (state, message) {
      state.loadingMessage = message
    },
    setLoadingActiveSubscription (state, payload) {
      state.loadingActiveSubscription = payload
    }
  },
  getters: {
    getLoadingState: (state) => state.loadingCount > 0,
    getLoadingMessage: (state) => state.loadingMessage,
    getLoadingActiveSubscription: (state) => state.loadingActiveSubscription
  }
}
